import React, { useState } from 'react'
import './index.scss'
import TableRow from '@Components/ViewWork/Table/TableRow'
import clsx from 'clsx'
import { TableRowData } from '@Components/ViewWork/Table'
import SubTable from '@Components/ViewWork/Table/SubTable'

interface TableExpandedRowProps {
    className: string
    tableRow: TableRowData
    removableCells?: boolean
    onRemoveCellClicked?: (removeCellIdentifier?: string) => void
}

const ExpandableTableRow = ({ className, tableRow, removableCells, onRemoveCellClicked }: TableExpandedRowProps) => {
    const [isExpanded, setIsExpanded] = useState(true)

    return (
        <>
            <TableRow
                className={clsx(className, tableRow.subTables && 'parent-table', isExpanded && 'expanded-row')}
                tableRow={tableRow}
                removableCells={removableCells}
                defaultExpanded={isExpanded}
                onRemoveCellClicked={onRemoveCellClicked && onRemoveCellClicked}
                onExpandCellClicked={(expanded) => setIsExpanded(expanded)}
            />
            {tableRow.subTables && isExpanded && (
                <div className="nested-table table-cell">
                    {tableRow.subTables.map((subTable, subTableIdx) => (
                        <SubTable {...subTable} key={`sub-row-table-${subTableIdx}`} />
                    ))}
                </div>
            )}
        </>
    )
}

export default ExpandableTableRow
